module.exports = __webpack_public_path__ + "static/img/case-zg-page-bg-04.97d5d25.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/zg/case-zg-page-bg-04.jpg
// module id = S54m
// module chunks = 1